import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { getErrors } from "../../utils";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { MarkInvoiceItemsAsSent, MarkInvoiceItemsAsSentVariables } from "./__generated__/MarkInvoiceItemsAsSent";

const MARK_INVOICE_ITEMS_AS_SENT = gql`
  mutation MarkInvoiceItemsAsSent($ids: [String!]) {
    markInvoiceItemsAsSent(input: { ids: $ids }) {
      invoiceItems {
        id
        startDate
        endDate
        amount
        sent
        organization {
          id
          name
        }
      }
    }
  }
`;

export function useMarkInvoiceItemsAsSent() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    MarkInvoiceItemsAsSent,
    MarkInvoiceItemsAsSentVariables
  >(MARK_INVOICE_ITEMS_AS_SENT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
